module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo8-6b034dfd141ac3e78150f7bb22f311e6.jpg";